import {
    backgroundContainer,
    main,
    progress,
    description,
    title,
    defaultFont,
    dangerColor,
    cardTitle,
    grayColor
} from "@app/assets/jss/material-kit-pro-react";

import customInputStyle from "@app/assets/jss/material-kit-pro-react/components/customInputStyle";
import customSelectStyle from '@app/assets/jss/material-kit-pro-react/components/customSelectStyle';
import customCheckboxRadioSwitch from '@app/assets/jss/material-kit-pro-react/components/customCheckboxRadioSwitchStyle';
import notificationsStyles from '@app/assets/jss/material-kit-pro-react/views/componentsSections/notificationsStyles';


const signUpPageStyle = theme => ({
    ...customSelectStyle,
    ...customCheckboxRadioSwitch,
    ...notificationsStyles,
    main: {
        ...main,
        marginTop: "0px",
        paddingTop: "0px",
        "&:before": {
            backgroundColor: "#ffffff",
            position: "absolute",
            width: "100%",
            height: "100%",
            minHeight: "100vh",
            display: "block",
            left: "0",
            top: "0",
            content: "''"
        }
    },
    progress: {
        ...progress,
        marginLeft: "-15px",
        marginRight: "-15px"
    },
    description,
    backgroundContainer,
    cardSignIn: {
        marginTop: "10px"
    },
    cardHeaderSignIn: {
        width: "auto",
        textAlign: "center",
        marginLeft: "20px",
        marginRight: "20px",
        padding: "20px 0",
        marginBottom: "15px"
    },
    justifyContentCenter: {
        display: "flex",
        WebkitBoxPack: "center !important",
        MsFlexPack: "center !important",
        justifyContent: "center !important"
    },
    inputIconsColor: {
        color: "#495057"
    },
    disabled: {
        ...customInputStyle.disabled
    },
    underline: {
        ...customInputStyle.underline
    },
    inputLabel: {
        ...customInputStyle.labelRoot,
        position: "absolute",
        left: "0"
    },
    cardTitle: {
        ...cardTitle,
        color: "#FFFFFF !important",
        marginBottom: "10px !important"
    },
    cardCategory: {
        marginTop: "10px"
    },
    cardSignUp: {
        marginTop: "10px",
        marginBottom: "0px"
    },
    cardHeaderSignUp: {
        width: "auto",
        textAlign: "center",
        marginLeft: "20px",
        marginRight: "20px",
        padding: "20px 0",
        marginBottom: "15px"
    },
    cardBodySignUp: {
        padding: "0px 30px 0px 30px"
    },
    cardBodySignUpButtons: {
        display: "flex",
        justifyContent: "center",
        "& button": {
            marginRight: "20px"
        },
        "& button:last-child": {
            marginRight: "0px"
        }
    },
    cardFooterSignUp: {
        display: "flex",
        justifyContent: "center"
    },
    title: {
        ...title,
        marginTop: "0px",
        marginBottom: "0px",
        textAlign: "center"
    },
    description: {
        color: "#999"
    },
    helperTextError: {
        ...defaultFont,
        color: dangerColor[0] + " !important",
        fontSize: "12px",
        fontWeight: "400",
        lineHeight: "1.42857",
        top: "10px",
        marginTop: "10px"
    },
    textAlignCenter: {
        textAlign: "center"
    },
    thumbnailFormControl: {
        margin: "0 0 17px 0",
        paddingTop: "27px",
        position: "relative"
    },
    cardThumbnail: {
        height: "0",
        paddingBottom: "60%",
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "auto",
        marginRight: "auto",
        backgroundPosition: "50%",
        backgroundSize: "cover",
        textAlign: "right",
        "&:after": {
            position: "absolute",
            zIndex: "1",
            width: "100%",
            height: "100%",
            display: "block",
            left: "0",
            top: "0",
            content: '""',
            backgroundColor: "unset",
            borderRadius: "6px"
        },
    },
    cardBodyThumbnail: {
        padding: "10px",
        zIndex: "2"
    },
    thumbnailSpinner: {
        color: grayColor[1],
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        marginTop: "30px"
    },
    thumbnailTitle: {
        ...title,
        marginTop: "0px",
        marginBottom: "0px",
        marginLeft: "5px",
        minHeight: "0px"
    },
    signUpInfoArea: {
        maxWidth: "360px",
        margin: "0 auto",
        padding: "30px 0 30px"
    },
    formControl: {
        margin: "0 0 17px 0",
        paddingTop: "27px",
        position: "relative",
        "& svg,& .fab,& .far,& .fal,& .fas,& .material-icons": {
            color: "#495057"
        },
        "& p": {
            color: "#000000"
        }
    },
    shareButtons: {
        display: "flex",
        justifyContent: "center"
    },
    whiteBG: {
        backgroundColor: "#ffffff"
    },
    divider: {
        border: "0",
        height: "1px",
        backgroundImage: "linear-gradient(to right, rgba(0, 0, 0, 0), rgba(0, 0, 0, 0.75), rgba(0, 0, 0, 0))" 
    },
    keySection: {
        color: dangerColor[0]
    },
    choice: {
        display: "flex",
        justifyContent: "center"
    }
});

export default signUpPageStyle;